import { Component, Inject, NgZone, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  templateUrl: './message-modal.html',
  styleUrls: ['./message-modal.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class MessageNoCSSModalComponent {
  title: string;
  message: string;
  closeWithZone: boolean = false;

  constructor(public dialogRef: MatDialogRef<MessageNoCSSModalComponent>, @Inject(MAT_DIALOG_DATA) data: any, private zone: NgZone) {
    this.title = data.title;
    this.message = data.message;
    this.closeWithZone = data.closeWithZone;
  }


  closeDialog()
  {
    if(this.closeWithZone)
    {
      this.zone.run(() => {
        this.dialogRef.close();
      });
    }
    else
    {
      this.dialogRef.close();
    }
    
  }
}
